export interface IStitchFeatureSection5Props {
  backgroundColor: string;
  dots1Color?: string;
  dots2Color?: string;
}

export const StitchFeatureSection5 = ({
  backgroundColor,
  dots1Color = "transparent",
  dots2Color = "transparent",
}: IStitchFeatureSection5Props) => {
  return (
    <div
      style={{ backgroundColor }}
      className="py-16 flex flex-col items-center justify-center gap-4"
    >
      <h2 className="text-6xl text-center px-4" style={{ maxWidth: "28ch" }}>
        How to Combine Photos?
      </h2>

      <div className="grid grid-cols-1  my-16 gap-8 px-4 items-center justify-center">
        <ul className=" list-decimal">
          <li>Click the “Select Photos” button and choose your photos</li>
          <li>Arrange photos in the desired order</li>

          <li>Click the “Save” button to download your combined photo.</li>
        </ul>
      </div>
    </div>
  );
};
